/**
 * @module Internet Service Provider
 * @description Internet Service Provider Page
 */
import Head from "next/head";
import Tooltip from "@/blocks/Tooltip";

// Template
import Template from "@/templates/Default";

// Blocks
import HeroAddressCheck from "@/blocks/Heroes/HeroAddressCheck";
import ColumnContent from "@/blocks/ColumnContent";
import SplitSectionPriceCopper from "@/blocks/SplitSectionPrice/SplitSectionPriceCopper";

/**
 * @function Page
 * @description Page
 */
const Page = () => (
  <>
    <Head>
      <title>Frontier Internet Service | Fast & Reliable Internet Plans</title>
      <meta
        name="description"
        content="Experience ultra-fast connectivity with Frontier Internet Service—reliable fiber internet with no data caps, perfect for streaming, gaming, and work. "
      />
      <link
        rel="canonical"
        href="https://frontier.com/shop/internet/internet-service-provider"
      />
    </Head>

    <Template
      title="Choose Frontier as Your Internet Service Provider"
      hero={
        <HeroAddressCheck
          headline={
            <>
              Connect at&nbsp;a{" "}
              <span key="span-1" className="u-color-blue">
                reliable price
              </span>
            </>
          }
          subHeadline={
            <>
              Go online all you want with zero data caps or overage charges no
              matter what.
              <Tooltip disclosure="data-caps" />
            </>
          }
          background="woman-on-laptop-internet-services-providers"
        />
      }
      primary={
        <>
          <ColumnContent
            useTiles
            theme="dark"
            headline={
              <>
                Why&nbsp;Frontier<sup>&reg;</sup> Internet?
              </>
            }
            subhead="We make it easy to stay connected"
            copyHeading
            items={[
              {
                icon: "speed-guage",
                headline: "No data caps or overage charges",
                content: (
                  <>
                    Work, learn, and live with unlimited data.
                    <Tooltip disclosure="data-caps" />
                  </>
                ),
              },
              {
                icon: "price-lock",
                headline: "2-year price guarantee",
                content: "Lock in one transparent price for two years.",
              },
              {
                icon: "wifi",
                headline: (
                  <>
                    Amazon eero Wi&#8209;Fi router on us
                    <span data-legal="eero" />
                  </>
                ),
                content: "Get Wi-Fi to stream and connect with confidence.",
              },
            ]}
          />

          <SplitSectionPriceCopper
            title="Work, learn, and live connected"
            basePrice={{ currency: "$", dollars: 49, cents: 99 }}
            promoPrice={{ currency: "$", dollars: 54, cents: 99 }}
            text={{
              shortLegal:
                "per month w/ Auto Pay and Paperless Bill. One-time charges apply.",
              annotationDisclosureKey: "new-residential-only",
            }}
          />
        </>
      }
    ></Template>
  </>
);
export default Page;
